import { render, staticRenderFns } from "./personManagement.vue?vue&type=template&id=4dff0c34&scoped=true&"
import script from "./personManagement.vue?vue&type=script&lang=js&"
export * from "./personManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff0c34",
  null
  
)

component.options.__file = "personManagement.vue"
export default component.exports